import BlogSection from "../atoms/BlogPreview";
import ContactForm from "../atoms/ContactForm";
import ServicesHeader from "../atoms/ServicesHeader";
import Button from "../components/v2/Button";
import Input from "../components/v2/Input";
import Textarea from "../components/v2/TextArea";
import Typography from "../components/v2/Typography";
import useApp from "../hooks/useApp";

const DomainAcquisitionNew = () => {

    const appCtx = useApp();

    return (
        <>
            <ServicesHeader active="/services/domain-acquisition" />
            {/* <!-- 1. HERO --> */}
            <section className="py-20 md:py-28 bg-white acquisition-service">
                <div className="container mx-auto px-4 max-w-6xl grid md:grid-cols-2 gap-12 items-start">
                    <div>
                        <h1 className="text-5xl font-bold leading-tight mb-6">Strategic Domain Acquisition Services</h1>
                        <p className="text-xl mb-4">Buy. Sell. Acquire. <strong>Confidentially</strong> and <strong>strategically</strong>.</p>
                        <p className="text-lg mb-6 max-w-xl">NameConnect brokers have closed <strong>$90 M+ in premium domain sales</strong>—names like <em>NEON.com</em>, <em>Cybersecurity.com</em>, and <em>League.com</em>. Whether you’re a Fortune 500 re‑branding under intense media scrutiny or a boot‑strapped founder chasing your dream .com, we provide the white‑glove roadmap from first valuation to flawless transfer.</p>
                        <ul className="list-disc list-inside space-y-2 text-lg">
                            <li>Global brand launches with zero leaks or speculation</li>
                        <li>Investor‑grade valuation reports that withstand boardrooms</li>
                        <li>24/7 access to your lead broker—real humans, real phones</li>
                    </ul>
                    </div>
                    {/* Callback Form */}
                    <div className="border-1 border-blue-500 p-8 shadow-sm bg-gray-50">
                        <h2 className="text-2xl font-semibold mb-4">Request a Callback</h2>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            console.log(e.target);
                            appCtx.submitForm(e.target.name.value, e.target.email.value, e.target.phone.value, e.target.query.value);
                        }} className="space-y-4">
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Name</Typography>
                                </div>
                                <Input isDark={true} name="name" label="" placeholder="John Doe" type="text" value="" onChange={() => { }} />
                            </div>
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Phone number</Typography>
                                </div>
                                <Input isDark={true} name="phone" label="" placeholder="+1 123456789" type="number" value="" onChange={() => { }} />
                            </div>
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Email</Typography>
                                </div>
                                <Input isDark={true} name="email" label="" placeholder="johndoe@gmail.com" type="email" value="" onChange={() => { }} />
                            </div>
                            <Textarea isDark={true} name="query" label="" value="" onChange={() => { }} style={{height: 170}} />
                            <Button variant="primary" type="submit" fullWidth>
                                <Typography variant="button">Submit</Typography>
                            </Button>
                            {/* <input type="text" name="name" placeholder="Name" required className="w-full p-3 border rounded" />
                            <input type="tel" name="phone" placeholder="Phone (optional)" className="w-full p-3 border rounded" />
                            <input type="email" name="email" placeholder="Email" required className="w-full p-3 border rounded" />
                            <textarea name="query" rows="4" placeholder="Target domain or question" className="w-full p-3 border rounded"></textarea>
                            <button type="submit" className="w-full py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded">Submit</button> */}
                        </form>
                    </div>
                    {/* <div className="service-form">
                    <ContactForm />
                    </div> */}

                </div>
            </section>

            {/* 2. WHY PREMIUM DOMAINS */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Why Premium Domains Still Outperform Every Other Asset Class</h2>
                    <p className="text-lg mb-4">A great .com is more than a URL—it’s global trust, type‑in traffic, and decades of brand equity distilled into one word. Over the last ten years, top‑tier domains have appreciated faster than prime Manhattan real estate and outpaced the S&amp;P 500 by more than 40 %. They do not depreciate, and there is no secondary market crash. When you own the category keyword—<em>Shield.com</em> for security, <em>Neon.com</em> for fintech, <em>Galaxy.com</em> for crypto—you instantly signal that you’re the market leader.</p>
                    <ul className="grid md:grid-cols-2 gap-6 text-lg list-disc list-inside">
                        <li><strong>Instant Credibility:</strong> 94 % of consumers distrust unfamiliar extensions. A .com anchors your legitimacy on contact page, business card, or billboard.</li>
                        <li><strong>Organic Traffic Lift:</strong> Exact‑match .coms routinely capture 20‑25 % direct‑type traffic without ad spend, lowering CAC from day one.</li>
                        <li><strong>Defensive Moat:</strong> Owning <em>YourKeyword.com</em> blocks competitors from siphoning traffic, reputation, and search authority.</li>
                        <li><strong>Resale &amp; Exit:</strong> Domains are liquid digital assets. Investors bundle them into IP portfolios and resell for 3‑10× within years.</li>
                    </ul>
                </div>
            </section>

            {/* 3. WHY BROKER */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Why Use a Domain Broker Instead of Going Direct</h2>
                    <p className="text-lg mb-4">Approaching a domain owner without a seasoned intermediary can add six figures to the price—or kill the deal outright. Domain sales combine real‑estate‑style scarcity with startup‑level hype cycles. A broker shields your identity, controls emotions, and runs a playbook refined over thousands of negotiations.</p>
                    <ol className="list-decimal list-inside space-y-3 text-lg">
                        <li><strong>Anonymity:</strong> We use proxy entities and blind escrow so owners never learn your budget or brand.</li>
                        <li><strong>Data‑Driven Valuation:</strong> Comparable sales, SEO value, trend analysis—translated into a defensible offer range.</li>
                        <li><strong>Speed to Engagement:</strong> Our rolodex includes 30 k+ verified owners, counsel, and marketplace insiders—most sellers respond within 72 hours.</li>
                        <li><strong>Legal &amp; Escrow Mastery:</strong> Pre‑vetted purchase agreements and KYC‑compliant escrow reduce risk to near‑zero.</li>
                        <li><strong>Performance Fee Alignment:</strong> No retainers; we only win when you do.</li>
                    </ol>
                </div>
            </section>

            {/* 4. WHAT WE DO */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Our Core Services</h2>
                    <div className="space-y-8 text-lg">
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Domain Acquisition</h3>
                            <p>Stealth outreach, valuation, and negotiation to secure a specific name—even if the owner swore they’d never sell. We’ve convinced century‑old conglomerates, crypto whales, and celebrity founders to part with prized domains by aligning incentives and crafting win‑win deal structures.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Domain Sales</h3>
                            <p>When it’s time to monetize, we position your domain to the right buyer pool—VC‑backed startups, strategic acquirers, or hedge‑fund bidders—maximizing exit value through targeted outreach and auction strategies.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Consulting &amp; Portfolio Strategy</h3>
                            <p>We audit existing domain portfolios, recommend defensive registrations, and design naming frameworks for product lines and international rollouts.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 5. WHAT SETS US APART */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">What Sets NameConnect Apart</h2>
                    <ul className="space-y-4 text-lg list-disc list-inside">
                        <li><strong>Eight‑Figure Resume:</strong> From <em>X.com</em>‑level legacy names to new‑economy keywords, our brokers have closed deals others called impossible.</li>
                        <li><strong>Cybersecurity DNA:</strong> Team members hail from top registrars and SOC‑2 compliant hosting firms; your data is encrypted and access‑controlled.</li>
                        <li><strong>Global Reach:</strong> Fluent in four languages, we negotiate across time zones and jurisdictions, handling VAT, RMB, and crypto settlements.</li>
                        <li><strong>24/7 Availability:</strong> Your launch date doesn’t sleep; neither do we. Get a real human on Signal at 2 AM.</li>
                        <li><strong>Contract Arsenal:</strong> Our attorney‑drafted templates cover IP assignments, seller representations, and claw‑backs—saving you $10 k+ in legal fees.</li>
                    </ul>
                </div>
            </section>

            {/* 6. PROCESS */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Our Six‑Step Acquisition Blueprint</h2>
                    <div className="space-y-8 text-lg">
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">1. Discovery &amp; Goal Alignment</h3>
                            <p>We start with a 30‑minute intake call to map your brand vision, budget ceiling, and launch timeline. Our team signs industry‑standard NDAs before any proprietary info is shared.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">2. Valuation &amp; Risk Matrix</h3>
                            <p>Using historical comp databases, SEO metrics, and brandability scoring, we establish a price corridor. We also audit legal encumbrances—trademarks, liens, UDRP history—so you avoid toxic assets.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">3. Stealth Outreach</h3>
                            <p>Your identity stays invisible while we contact the owner through proxy corporations, trusted attorneys, or discreet social channels. 82 % of owners reply within the first five touches.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">4. Negotiation &amp; Deal Architecture</h3>
                            <p>We present tiered offers, equity kickers, or lease‑to‑own models tailored to seller psychology. Our average closing price lands 18 % below initial ask.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">5. Escrow &amp; Compliance</h3>
                            <p>Funds flow through Escrow.com or attorney trust. We coordinate KYC, OFAC checks, and tax paperwork so finance teams sign off instantly.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">6. Technical Transfer &amp; Post‑Launch Support</h3>
                            <p>Our engineers walk your dev‑ops lead through registrar push, DNS hardening, and SSL deployment—then monitor propagation for 72 hours to catch hiccups before they hit customers.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 7. CASE STUDIES */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Select Wins &amp; Client Stories</h2>
                    <ul className="grid md:grid-cols-2 gap-8 text-lg list-disc list-inside">
                        <li><strong>Cybersecurity.com</strong> – secured for a Nasdaq‑listed security firm 32 % under budget after a three‑year owner stalemate.</li>
                        <li><strong>League.com</strong> – brokered in 11 days for a sports‑tech startup preparing Series B PR blitz; zero leaks to press.</li>
                        <li><strong>Cryptocurrency.com</strong> – structured as lease‑to‑own with revenue share, aligning cash‑flow constraints with seller upside.</li>
                        <li><strong>Neon.com</strong> – convinced legacy electrical supplier to divest, delivering 200 k/mo type‑in traffic to a fintech rebrand.</li>
                    </ul>
                </div>
            </section>

            {/* 8. FEES */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl grid md:grid-cols-2 gap-8 items-start">
                    <div>
                        <h2 className="text-3xl font-semibold mb-6">Our Performance‑Based Fee Model</h2>
                        <p className="text-lg mb-4">You invest in results, not retainers. We structure fees to align incentives and maximize your ROI.</p>
                        <ul className="space-y-3 text-lg list-disc list-inside">
                            <li><strong>15 % of purchase price</strong> (min&nbsp;$2,500) for one‑off acquisitions</li>
                            <li><strong>10 % tier</strong> for multi‑domain or portfolio engagements</li>
                            <li><strong>No success, no fee</strong>. Upfront retainers only for complex multi‑party corporate carve‑outs</li>
                        </ul>
                    </div>
                    <div className="bg-blue-50 p-6 rounded text-center shadow-sm">
                        <p className="text-xl font-medium">“NameConnect saved us six figures versus going direct—worth every basis point.”<br /><span className="text-sm">— CFO, Series C SaaS Unicorn</span></p>
                    </div>
                </div>
            </section>

            {/* 9. SECURITY & CONFIDENTIALITY */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Security &amp; Confidentiality First</h2>
                    <p className="text-lg mb-4">We treat domain deals like M&amp;A transactions—encrypted comms, minimal‑disclosure NDAs, and zero public records. Every file is stored in ISO‑27001 certified cloud drives and auto‑purged after close unless compliance requires retention.</p>
                </div>
            </section>

            {/* 10. CTA */}
            <section className="py-20 bg-blue-600 text-white text-center">
                <div className="container mx-auto px-4 max-w-4xl">
                    <h2 className="text-4xl font-bold mb-4">Ready to Own Your Category‑Defining Domain?</h2>
                    <p className="text-lg mb-8">Call <a href="tel:+19415009689" className="underline">+1 (941) 500‑9689</a> or email <a href="mailto:broker@nameconnect.com" className="underline">broker@nameconnect.com</a>. We answer in under 60 minutes—because timing kills deals.</p>
                    <a href="/contact" className="inline-block bg-white text-blue-600 font-semibold py-4 px-10 rounded">Schedule a Discovery Call</a>
                </div>
            </section>

            <BlogSection />
        </>
    );
};

export default DomainAcquisitionNew;